<div id="{{this.propertyId}}Form" [formGroup]="this.formGroup" *ngIf="this.formGroup">

  <app-text-field [LABEL_SPACING]="0" id="legalFirstName" label='Legal first name' propertyName="legalFirstName" [formGroup]="this.formGroup" [regular]="regular">
  </app-text-field>
   
  <app-text-field [LABEL_SPACING]="0" id="legalLastName" label='Legal last name' propertyName="legalLastName" [formGroup]="this.formGroup" [regular]="regular">
  </app-text-field>

  <app-phone-field [LABEL_SPACING]="0" id="phoneNumber" label='Phone number' propertyName="phoneNumber" [formGroup]="this.formGroup" [regular]="regular">
   </app-phone-field> 

   <app-text-field [LABEL_SPACING]="0"  id="email" label='Email address' propertyName="email" [formGroup]="this.formGroup" [regular]="regular">
  </app-text-field>

  <div class="row">
    <div class="col-md-4">
      <app-dropdown-field [LABEL_SPACING]="0" id="firmTypeRelationship" [label]='this.firmTypeRelationshipTitle' propertyName='firmTypeRelationship'
                          (userInput)="this.addNewFields($event)"
                          [formGroup]="this.formGroup" [dropdownData]="this.relationshipData" [regular]="regular">
      </app-dropdown-field>
    </div>
  </div>

   <div *ngIf="this.formGroup.controls.firmTypeRelationship.value == this.otherTypeCode && 
   this.formGroup.controls.otherDesc != null">
      <app-text-field [LABEL_SPACING]="0" id="otherDesc" [label]='this.otherLabel' 
                    propertyName="otherDesc" [formGroup]="this.formGroup" [regular]="regular">
    </app-text-field>
  </div>

  <div class="row">
    <div class="col-md-5">
      <div *ngIf="this.formGroup.controls.firmTypeRelationship.value == this.ownerOrShareholderTypeCode
         && this.formGroup.controls.birthDate != null">
        <app-date-control id="birthDate" formControlName="birthDate" label='Date of birth' [numberOfPastYear]="100"
                          [numberOfFutureYear]="0">
        </app-date-control>
      </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-md-12">
      <div *ngIf="this.formGroup.controls.firmTypeRelationship.value == this.ownerOrShareholderTypeCode">
        <h2>Your mailing address </h2>
            <p class="mb-0">Please provide your mailing address. You will be able to provide the business’s mailing
               address later in this application, if different.</p>
      </div>
    </div>
  </div>


  <div [hidden]="!(formGroup.controls.firmTypeRelationship.value === ownerOrShareholderTypeCode && formGroup.controls.addressLine1.value !== null)" class="mt-40" >
    <div class="row">
      <div class="col-md-9">
        <div class="form-label">Address lookup</div>
      </div>
    </div>
    
      <div class="row">
        <div class="col col-md-4">
          <input class="form-control mr-2" type="text" id="search" placeholder="Start typing your address..." autocomplete="off">
        </div>
      </div>
  </div>

    <div *ngIf="this.formGroup.controls.firmTypeRelationship.value == this.ownerOrShareholderTypeCode && this.formGroup.controls.addressLine1 != null">

      <div class="row" >     
        <div  class="col">
          <app-mailing-address        
              propertyId="ownerOrShareholderAddress"                 
              [addressTypesData]="this.addressTypesData"       
              [formGroup]="this.formGroup" >
          </app-mailing-address>   
        </div>
      </div> 

    </div>
</div> 